import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Panel } from "../components/layout/Panel";
import { CompGrid, type Column } from "../components/grid/CompGrid";
import { Link as MuiLink } from "@mui/material";
import { useHierarchyContext } from "../contexts/HierarchyContext";
import type { TenantWithRole } from "../api/management";

export function HomePage() {
  const { tenants, loading, error } = useHierarchyContext();

  const columns: Column<TenantWithRole>[] = [
    {
      id: "slug",
      label: "Slug",
      sortable: true,
      sortValue: (t) => t.slug,
      render: (t) => (
        <MuiLink
          component={RouterLink}
          to={`/tenants/${encodeURIComponent(t.slug)}/products`}
          underline="hover"
        >
          <Typography variant="body2" className="om-text-mono">
            {t.slug}
          </Typography>
        </MuiLink>
      ),
    },
    {
      id: "name",
      label: "Name",
      sortable: true,
      sortValue: (t) => t.name,
      render: (t) => <Typography variant="body2">{t.name}</Typography>,
    },
    {
      id: "description",
      label: "Description",
      render: (t) => (
        <Typography variant="body2" sx={{ opacity: 0.75 }}>
          {t.description || "-"}
        </Typography>
      ),
    },
    {
      id: "actions",
      label: (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mx: 4 }}>
          <Button
            size="small"
            variant="text"
            component={RouterLink}
            to="/tenants/new"
            disabled={loading || !!error}
          >
            Create
          </Button>
        </Box>
      ),
      render: (t) => (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mx: 4 }}>
          <Button
            size="small"
            variant="text"
            component={RouterLink}
            to={`/tenants/${encodeURIComponent(t.slug)}/products`}
          >
            Open
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Panel title="Tenants">
        <CompGrid
          items={tenants}
          loading={loading}
          error={error?.message ?? null}
          emptyMessage="No tenants yet."
          columns={columns}
          keyExtractor={(t) => t.slug}
        />
      </Panel>
    </Box>
  );
}
